import React from "react";
import {
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  BarChart,
  Bold,
  Bell,
  Bug,
  Building2,
  CalendarRange,
  Camera,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  Clock,
  ClipboardPaste,
  Code,
  CreditCard,
  Copy,
  Cylinder,
  Database,
  Disc,
  Download,
  Earth,
  Equal,
  ExternalLink,
  Eye,
  FileDown,
  Flag,
  FileText,
  Files,
  Filter,
  GripVertical,
  History,
  Image,
  MessageCircle,
  Paperclip,
  Phone,
  ArrowUpDown,
  Route,
  Tag,
  Zap,
  Globe,
  Goal,
  HelpCircle,
  Italic,
  Info,
  Layers,
  List,
  ListFilter,
  Lock,
  Mail,
  EyeOff,
  Maximize2,
  Menu,
  Minimize2,
  Minus,
  Loader2,
  Monitor,
  Moon,
  Home,
  LogOut,
  MessageSquareShare,
  MoreHorizontal,
  MoreVertical,
  Settings2,
  SquareActivity,
  Package,
  PanelLeft,
  PanelLeftOpen,
  PanelRight,
  PanelRightOpen,
  Pencil,
  Play,
  Plus,
  RefreshCw,
  RotateCcw,
  RotateCw,
  Save,
  Search,
  Send,
  SendHorizontal,
  Settings,
  SlidersHorizontal,
  Square,
  Star,
  Strikethrough,
  Sun,
  ThumbsDown,
  ThumbsUp,
  Trash2,
  Underline,
  Unlock,
  User,
  VectorSquare,
  Waypoints,
  X,
  Spline,
  Slash, ArrowUpFromLine, ArrowDownFromLine,
  Indent, Outdent, Bookmark, CornerDownLeft, ListOrdered, CloudDownload,
  Undo2,
  Redo2,
  SquarePen,
  TextCursorInput,
  UploadIcon,
  Signpost,
  Hash,
  GalleryVerticalEnd,
  Type,
  GalleryHorizontalEnd,
  DollarSign,
  ClipboardList,
  Table,
  SquareMenu,
  Braces,
  TextQuote,
  Link,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Pilcrow,
  SquareCode,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Unlink,
  Ban,
  CodeXml,
  SquareText,
} from "lucide-react";

import {
  AccountIcon,
  AddcolumnleftIcon,
  AddcolumnrightIcon,
  AddfileIcon,
  AddgroupIcon,
  AddheaderIcon,
  AddrowbelowIcon,
  AddrowtopIcon,
  AddruleIcon,
  AddtableIcon,
  AnalystIcon,
  ArrowdownrightIcon,
  AutoIcon,
  AutogenIcon,
  AutogenpenIcon,
  BillingIcon,
  BooleanIcon,
  BrowseIcon,
  BrowseallIcon,
  BuildIcon,
  CalendartimeIcon,
  CheckboxIcon,
  CitizenshipIcon,
  ClearIcon,
  CompareIcon,
  CurrencyIcon,
  DashboardIcon,
  DatasheetIcon,
  DebugIcon,
  DefinedInIcon,
  DeletecolumnIcon,
  DeleterowIcon,
  DependencyIcon,
  DesignIcon,
  DesignerIcon,
  DeveloperIcon,
  DocumentsIcon,
  DropdownIcon,
  EqualIcon,
  FacescanIcon,
  FingerprintIcon,
  FolderFilledIcon,
  FolderIcon,
  FolderOpenIcon,
  FormscreenIcon,
  FormstageIcon,
  FunctionsIcon,
  GlossaryIcon,
  GuidIcon,
  HidefilesIcon,

  IdIcon,
  ImplementationIcon,
  IndeterminateIcon,
  IngestIcon,
  InnovateIcon,
  InstancesIcon,
  InteractionsIcon,
  InterviewIcon,
  LabelIcon,
  LayoutIcon,
  LessequalIcon,
  LessthanIcon,
  Level1Icon,
  Level2Icon,
  Level3Icon,
  Level4Icon,
  Level5Icon,
  Level6Icon,
  LinkingIcon,
  LocationIcon,
  MapIcon,
  MatrixIcon,
  MenudotsIcon,
  MergeIcon,
  MonitorIcon,
  MoreequalIcon,
  MorethanIcon,
  MoveIcon,
  NonruleIcon,
  NotequalIcon,
  NotificationIcon,
  OutcomeIcon,
  PallettIcon,
  PinemptyIcon,
  PinfilledIcon,
  PrivatelinkIcon,
  ProjectsIcon,
  PubliclinkIcon,
  QrIcon,
  RadiobuttonIcon,
  RedoIcon,
  ReportsIcon,
  ResetgraphIcon,
  RetryIcon,
  ShowfilesIcon,
  SignatureIcon,
  SliderIcon,
  SnippetIcon,
  SplitIcon,
  StaremptyIcon,
  StarfilledIcon,
  SubtractIcon,
  SystemfileIcon,
  TableIcon,
  TablesettingsIcon,
  TargetIcon,
  TasksIcon,
  TestingIcon,
  TextfieldIcon,
  TooltipIcon,
  TypographyIcon,
  UncertainIcon,
  UndoIcon,
  UnknownIcon,
  UploadfileIcon,
  UserrolesIcon,
  UsersIcon,
  VerbIcon,
  VerifyIcon,
  VersionhistoryIcon,
  ViewIcon,
  ZoominIcon,
  ZoomoutIcon,
} from "./generated";

import { type IconName, type IconProps, ICONS } from "./Icon";
import { number } from "zod";

const GENERATED_ICON_COMPONENTS: Record<string, React.ComponentType<any>> = {
  account: AccountIcon,
  "add-column-left": AddcolumnleftIcon,
  "add-column-right": AddcolumnrightIcon,
  "add-file": AddfileIcon,
  "add-group": AddgroupIcon,
  "add-header": AddheaderIcon,
  "add-row-below": AddrowbelowIcon,
  "add-row-top": AddrowtopIcon,
  "add-rule": AddruleIcon,
  "add-table": AddtableIcon,
  analyst: AnalystIcon,
  "arrow-down-right": ArrowdownrightIcon,
  auto: AutoIcon,
  "auto-generate": AutogenIcon,
  "auto-generate-pen": AutogenpenIcon,
  billing: BillingIcon,
  boolean: BooleanIcon,
  browse: BrowseIcon,
  "browse-all": BrowseallIcon,
  build: BuildIcon,
  "calendar-time": CalendartimeIcon,
  checkbox: CheckboxIcon,
  citizenship: CitizenshipIcon,
  clear: ClearIcon,
  compare: CompareIcon,
  currency: CurrencyIcon,
  dashboard: DashboardIcon,
  datasheet: DatasheetIcon,
  debug: DebugIcon,
  "defined-in": DefinedInIcon,
  "delete-column": DeletecolumnIcon,
  "delete-row": DeleterowIcon,
  dependency: DependencyIcon,
  design: DesignIcon,
  designer: DesignerIcon,
  developer: DeveloperIcon,
  documents: DocumentsIcon,
  dropdown: DropdownIcon,
  equal: EqualIcon,
  "face-scan": FacescanIcon,
  fingerprint: FingerprintIcon,
  "folder-filled": FolderFilledIcon,
  "folder-open": FolderOpenIcon,
  "form-screen": FormscreenIcon,
  "form-stage": FormstageIcon,
  functions: FunctionsIcon,
  glossary: GlossaryIcon,
  guid: GuidIcon,
  "hide-files": HidefilesIcon,
  home: Home,
  id: IdIcon,
  implementation: ImplementationIcon,
  indeterminate: IndeterminateIcon,
  ingest: IngestIcon,
  innovate: InnovateIcon,
  instances: InstancesIcon,
  interactions: InteractionsIcon,
  interview: InterviewIcon,
  label: LabelIcon,
  layout: LayoutIcon,
  "less-equal": LessequalIcon,
  "less-than": LessthanIcon,
  "level-1": Level1Icon,
  "level-2": Level2Icon,
  "level-3": Level3Icon,
  "level-4": Level4Icon,
  "level-5": Level5Icon,
  "level-6": Level6Icon,
  linking: LinkingIcon,
  location: LocationIcon,
  map: MapIcon,
  matrix: MatrixIcon,
  merge: MergeIcon,
  "monitor-icon": MonitorIcon,
  "more-equal": MoreequalIcon,
  "more-than": MorethanIcon,
  move: MoveIcon,
  "non-rule": NonruleIcon,
  "not-equal": NotequalIcon,
  notification: NotificationIcon,
  outcome: OutcomeIcon,
  palette: PallettIcon,
  "pin-empty": PinemptyIcon,
  "pin-filled": PinfilledIcon,
  "private-link": PrivatelinkIcon,
  projects: ProjectsIcon,
  "public-link": PubliclinkIcon,
  qr: QrIcon,
  "radio-button": RadiobuttonIcon,
  "redo-icon": RedoIcon,
  reports: ReportsIcon,
  "reset-graph": ResetgraphIcon,
  retry: RetryIcon,
  "show-files": ShowfilesIcon,
  signature: SignatureIcon,
  slider: SliderIcon,
  snippet: SnippetIcon,
  split: SplitIcon,
  "star-empty": StaremptyIcon,
  "star-filled": StarfilledIcon,
  subtract: SubtractIcon,
  "system-file": SystemfileIcon,
  table: TableIcon,
  "table-settings": TablesettingsIcon,
  target: TargetIcon,
  tasks: TasksIcon,
  testing: TestingIcon,
  "text-field": TextfieldIcon,
  tooltip: TooltipIcon,
  typography: TypographyIcon,
  uncertain: UncertainIcon,
  "undo-icon": UndoIcon,
  unknown: UnknownIcon,
  "upload-file": UploadfileIcon,
  "user-roles": UserrolesIcon,
  users: UsersIcon,
  verb: VerbIcon,
  verify: VerifyIcon,
  "version-history": VersionhistoryIcon,
  view: ViewIcon,
  "zoom-in": ZoominIcon,
  "zoom-out": ZoomoutIcon,
};

const LUCIDE_ICON_COMPONENTS: Record<string, React.ComponentType<any>> = {
  close: X,
  search: Search,
  add: Plus,
  "expand-section": ChevronDown,
  "collapse-section": ChevronUp,
  submenu: ChevronRight,
  "tree-expand": ChevronRight,
  download: Download,
  selected: Check,
  "radio-selected": Circle,
  "show-more": MenudotsIcon,
  "show-data": List,
  refresh: RefreshCw,
  undo: Undo2,
  redo: Redo2,
  history: History,
  help: HelpCircle,
  edit: Pencil,
  value: Equal,
  error: AlertCircle,
  maximize: Maximize2,
  minimize: Minimize2,
  "expand-pane": PanelLeftOpen,
  "collapse-pane": PanelRightOpen,
  save: Save,
  delete: Trash2,
  info: Info,
  settings: Settings,
  filter: Filter,
  "filter-list": ListFilter,
  copy: Copy,
  "go-back": ChevronLeft,
  "go-forward": ChevronRight,
  "go-first": ChevronsLeft,
  "go-last": ChevronsRight,
  collapse: ChevronUp,
  expand: ChevronDown,
  check: Check,
  success: CheckCircle,
  warning: AlertTriangle,
  "move-up": ArrowUp,
  "move-down": ArrowDown,
  "open-in-new": ExternalLink,
  reset: RotateCcw,
  sun: Sun,
  moon: Moon,
  monitor: Monitor,
  menu: Menu,
  lock: Lock,
  unlock: Unlock,
  minus: Minus,
  star: Star,
  paste: ClipboardPaste,
  duplicate: Files,
  visibility: Eye,
  code: Code,
  document: FileText,
  play: Play,
  continue: ArrowRightCircle,
  database: Database,
  adjust: SlidersHorizontal,
  layers: Layers,
  send: Send,
  "send-horizontal": SendHorizontal,
  "import-file": FileDown,
  record: Disc,
  approve: ThumbsUp,
  reject: ThumbsDown,
  "view-chart": BarChart,
  camera: Camera,
  globe: Globe,
  bell: Bell,
  "credit-card": CreditCard,
  "open-sidebar": PanelLeft,
  "open-panel": PanelRight,
  resize: ChevronsUpDown,
  "data-store": Cylinder,
  earth: Earth,
  bug: Bug,
  waypoints: Waypoints,
  rotate: RotateCw,
  relationship: Spline,
  goal: Goal,
  building: Building2,
  package: Package,
  entity: VectorSquare,
  text: TextCursorInput,
  boolean: Check,
  typography: Type,
  currency: DollarSign,
  date: CalendarRange,
  time: Clock,
  options: SquareMenu,
  radio: Circle,
  number: Hash,
  number_of_instances: GalleryHorizontalEnd,
  file: UploadIcon,
  generative_chat: MessageCircle,
  repeating_container: GalleryVerticalEnd,
  certainty_container: AlertCircle,
  switch_container: Signpost,
  data_container: Table,
  interview_container: ClipboardList,
  "date-range": CalendarRange,
  clock: Clock,
  person: User,
  email: Mail,
  "file-copy": Copy,
  hide: EyeOff,
  tag: Tag,
  image: Image,
  drag: GripVertical,
  trigger: Zap,
  phone: Phone,
  attach: Paperclip,
  sort: ArrowUpDown,
  timeline: Route,
  message: MessageCircle,
  bold: Bold,
  italic: Italic,
  underline: Underline,
  strikethrough: Strikethrough,
  stop: Square,
  flag: Flag,
  slash: Slash,
  "map-response": ArrowUpFromLine,
  "map-request": ArrowDownFromLine,
  "list-indent-increase": Indent,
  "list-indent-decrease": Outdent,
  bookmark: Bookmark,
  "keyboard-return": CornerDownLeft,
  list: List,
  "list-ordered": ListOrdered,
  "cloud-download": CloudDownload,
  metadata: SquarePen,
  rename: TextCursorInput,
  upload: UploadIcon,
  "more-horizontal": MoreHorizontal,
  "message-square-share": MessageSquareShare,
  "log-out": LogOut,
  "square-activity": SquareActivity,
  "settings-2": Settings2,
  braces: Braces,
  quote: TextQuote,
  link: Link,
  "heading-1": Heading1,
  "heading-2": Heading2,
  "heading-3": Heading3,
  "heading-4": Heading4,
  paragraph: Pilcrow,
  "code-block": SquareCode,
  "align-left": AlignLeft,
  "align-center": AlignCenter,
  "align-right": AlignRight,
  "align-justify": AlignJustify,
  unlink: Unlink,
  ban: Ban,
  "code-xml": CodeXml,
  "square-text": SquareText,
};

type LucideIconProps = IconProps & { ref?: React.Ref<SVGSVGElement> };
const LucideIcon = (props: LucideIconProps) => {
  const { ref } = props;
  const { name, fallbackName, size, style, ...otherProps } = props;
  const Component = LUCIDE_ICON_COMPONENTS[name] ?? GENERATED_ICON_COMPONENTS[name] ?? (fallbackName ? LUCIDE_ICON_COMPONENTS[fallbackName] ?? GENERATED_ICON_COMPONENTS[fallbackName] : null);

  if (!Component) return null;

  const data = ICONS[name] ?? (fallbackName ? ICONS[fallbackName] : null);
  const ariaLabel = props["aria-label"] ?? (data ? data.label : undefined);

  const dimensions =
    size !== undefined
      ? typeof size === "number"
        ? { width: `${size}px`, height: `${size}px` }
        : { width: size, height: size }
      : {};

  return (
    <Component
      ref={ref}
      aria-label={ariaLabel}
      data-deci-icon="true"
      style={{ ...dimensions, ...style }}
      {...otherProps}
    />
  );
};

export default LucideIcon;
